import { defineMessages } from 'react-intl'

export const messages = defineMessages({
  pageTitle: {
    id: 'djcity.common.comparison.meta.title',
    defaultMessage: 'Effortless integration with all DJ software',
  },
  pageDescription: {
    id: 'djcity.common.comparison.meta.description',
    defaultMessage: 'Effortless integration with all DJ software',
  },
  title: {
    id: 'djcity.common.comparison.title',
    defaultMessage: 'DJ DOWNLOAD RECORD POOL COMPARISON',
  },
  subtitle: {
    id: 'djcity.common.comparison.subtitle',
    defaultMessage: 'DJcity is the best record pool for beginner & expert DJs',
  },
  c2aTitle: {
    id: 'djcity.common.comparison.c2a.title',
    defaultMessage: "Get Instant Access to the Industry's Top Record Pool!",
  },
  c2aButton: {
    id: 'djcity.common.comparison.c2a.button',
    defaultMessage: 'Join Now',
  },
  faqTitle: {
    id: 'djcity.common.comparison.faq.title',
    defaultMessage: 'Learn More About DJcity',
  },
})

export const pricingMsg = [
  defineMessages({
    title: {
      id: 'djcity.common.pricing.title',
      defaultMessage: 'Pricing',
    },
  }),
  defineMessages({
    duration: {
      id: 'djcity.common.pricing.monthly.duration',
      defaultMessage: '1 Month Access',
    },
    price: {
      id: 'djcity.common.pricing.monthly.price',
      defaultMessage: '30$ <span>/mo</span>',
    },
    ppm: {
      id: 'djcity.common.pricing.monthly.ppm',
      defaultMessage: '($30 / mo)',
    },
  }),
  defineMessages({
    duration: {
      id: 'djcity.common.pricing.biannual.duration',
      defaultMessage: '6 Months Access',
    },
    price: {
      id: 'djcity.common.pricing.biannual.price',
      defaultMessage: '150$ <span>/mo</span>',
    },
    ppm: {
      id: 'djcity.common.pricing.biannual.ppm',
      defaultMessage: '($25 / mo)',
    },
    saving: {
      id: 'djcity.common.pricing.biannual.saving',
      defaultMessage: 'SAVE $30',
    },
    header: {
      id: 'djcity.common.pricing.biannual.header',
      defaultMessage: 'BEST VALUE',
    },
  }),
]

export const featuresMessages = [
  defineMessages({
    djcity: {
      id: 'djcity.common.comparison.feature1.djcity',
      defaultMessage: 'Full Access To All Playlists',
    },
    title: {
      id: 'djcity.common.comparison.feature1.title',
      defaultMessage: 'PLAYLISTS FOR ALL <span>DJS</span>',
    },
    competitors: {
      id: 'djcity.common.comparison.feature1.competitors',
      defaultMessage: 'Extra Cost For Full Access',
    },
  }),
  defineMessages({
    djcity: {
      id: 'djcity.common.comparison.feature2.djcity',
      defaultMessage: 'Exclusive DJcity Remixes & edits',
    },
    title: {
      id: 'djcity.common.comparison.feature2.title',
      defaultMessage: 'HIDDEN GEMS ONLY ON <span>DJCITY</span>',
    },
    competitors: {
      id: 'djcity.common.comparison.feature2.competitors',
      defaultMessage: 'not available',
    },
  }),
  defineMessages({
    djcity: {
      id: 'djcity.common.comparison.feature3.djcity',
      defaultMessage: 'Multiple Bulk Download Options',
    },
    title: {
      id: 'djcity.common.comparison.feature3.title',
      defaultMessage: 'STREAMLINED DJ <span>WORKFLOW</span>',
    },
    competitors: {
      id: 'djcity.common.comparison.feature3.competitors',
      defaultMessage: 'not available',
    },
  }),
  defineMessages({
    djcity: {
      id: 'djcity.common.comparison.feature4.djcity',
      defaultMessage: '250+ genres',
    },
    title: {
      id: 'djcity.common.comparison.feature4.title',
      defaultMessage: 'EVERY STYLE OF <span>MUSIC</span>',
    },
    competitors: {
      id: 'djcity.common.comparison.feature4.competitors',
      defaultMessage: '<100 genres',
    },
  }),
  defineMessages({
    djcity: {
      id: 'djcity.common.comparison.feature5.djcity',
      defaultMessage: 'Endless Recommendations',
    },
    title: {
      id: 'djcity.common.comparison.feature5.title',
      defaultMessage: 'UNLIMITED MUSIC <span>DISCOVERY</span>',
    },
    competitors: {
      id: 'djcity.common.comparison.feature5.competitors',
      defaultMessage: 'limited availability',
    },
  }),
  defineMessages({
    djcity: {
      id: 'djcity.common.comparison.feature6.djcity',
      defaultMessage: 'Full Access To All Music',
    },
    title: {
      id: 'djcity.common.comparison.feature6.title',
      defaultMessage: 'GLOBAL MUSIC <span>CATALOG</span>',
    },
    competitors: {
      id: 'djcity.common.comparison.feature6.competitors',
      defaultMessage: 'Extra Cost For Full Access',
    },
  }),
  defineMessages({
    djcity: {
      id: 'djcity.common.comparison.header.djcity',
      defaultMessage: '🏆 DJcity:',
    },
    competitors: {
      id: 'djcity.common.comparison.header.competitors',
      defaultMessage: '❌ Competitors:',
    },
  }),
]

export const tableMessages = {
  header: defineMessages({
    col1: {
      id: 'djcity.common.comparison.header.col1',
      defaultMessage: 'Comparison',
    },
    col2: {
      id: 'djcity.common.comparison.header.col2',
      defaultMessage: 'DJCity',
    },
    col3: {
      id: 'djcity.common.comparison.header.col3',
      defaultMessage: 'vs. BPM Supreme',
    },
    col4: {
      id: 'djcity.common.comparison.header.col4',
      defaultMessage: 'vs. ZIP DJ',
    },
  }),
  cost: defineMessages({
    title: {
      id: 'djcity.common.comparison.title.cost',
      defaultMessage: 'Cost',
    },
    djcity: {
      id: 'djcity.common.comparison.djcity.cost',
      defaultMessage:
        '🏆 10$ Intro price<br/>🏆 30$/month for full access<br />🏆260$/year for full access',
    },
    bpmsupreme: {
      id: 'djcity.common.comparison.bpmsupreme.cost',
      defaultMessage:
        '🚫 No intro price<br/>🚫 $69/month for full access<br />🚫630$/year for full access',
    },
    zipdj: {
      id: 'djcity.common.comparison.zipdj.cost',
      defaultMessage:
        '🚫 35$ intro price<br/>🚫 $50/month for full access<br />🚫420$/year for full access',
    },
  }),
  catalog: defineMessages({
    title: {
      id: 'djcity.common.comparison.title.catalog',
      defaultMessage: 'Global Music Catalog',
    },
    djcity: {
      id: 'djcity.common.comparison.djcity.catalog',
      defaultMessage: '🏆 Full access to global music',
    },
    bpmsupreme: {
      id: 'djcity.common.comparison.bpmsupreme.catalog',
      defaultMessage: '🚫 Extra cost for full music access',
    },
    zipdj: {
      id: 'djcity.common.comparison.zipdj.catalog',
      defaultMessage: '🚫 Extra cost for full music access',
    },
  }),
  playlists: defineMessages({
    title: {
      id: 'djcity.common.comparison.title.playlists',
      defaultMessage: 'DJ Curated Playlists',
    },
    djcity: {
      id: 'djcity.common.comparison.djcity.playlists',
      defaultMessage: '🏆 Full access to all playlists',
    },
    bpmsupreme: {
      id: 'djcity.common.comparison.bpmsupreme.playlists',
      defaultMessage: 'Extra cost for full playlist access',
    },
    zipdj: {
      id: 'djcity.common.comparison.zipdj.playlists',
      defaultMessage: 'Extra cost for full playlist access',
    },
  }),
  remixes: defineMessages({
    title: {
      id: 'djcity.common.comparison.title.remixes',
      defaultMessage: 'Exclusive Remixes',
    },
    djcity: {
      id: 'djcity.common.comparison.djcity.remixes',
      defaultMessage: '🏆 Remixes and edits available only on DJcity',
    },
    bpmsupreme: {
      id: 'djcity.common.comparison.bpmsupreme.remixes',
      defaultMessage: 'Extra cost for full remix access',
    },
    zipdj: {
      id: 'djcity.common.comparison.zipdj.remixes',
      defaultMessage: '🚫 Not available',
    },
  }),
  desktopDownloads: defineMessages({
    title: {
      id: 'djcity.common.comparison.title.desktopDownloads',
      defaultMessage: 'Bulk Downloads - Desktop App',
    },
    djcity: {
      id: 'djcity.common.comparison.djcity.desktopDownloads',
      defaultMessage: '🏆 Remote downloads using your phone or computer',
    },
    bpmsupreme: {
      id: 'djcity.common.comparison.bpmsupreme.desktopDownloads',
      defaultMessage: '🚫 Not available',
    },
    zipdj: {
      id: 'djcity.common.comparison.zipdj.desktopDownloads',
      defaultMessage: '🚫 Not available',
    },
  }),
  browserDownloads: defineMessages({
    title: {
      id: 'djcity.common.comparison.title.browserDownloads',
      defaultMessage: 'Bulk Downloads - In-Browser',
    },
    djcity: {
      id: 'djcity.common.comparison.djcity.browserDownloads',
      defaultMessage:
        '🏆 Instant access to native MP3 files with a single click',
    },
    bpmsupreme: {
      id: 'djcity.common.comparison.bpmsupreme.browserDownloads',
      defaultMessage: 'Inconvenient ZIP files',
    },
    zipdj: {
      id: 'djcity.common.comparison.zipdj.browserDownloads',
      defaultMessage: 'Inconvenient ZIP files',
    },
  }),
  mobileDownloads: defineMessages({
    title: {
      id: 'djcity.common.comparison.title.mobileDownloads',
      defaultMessage: 'Bulk Downloads - Mobile App',
    },
    djcity: {
      id: 'djcity.common.comparison.djcity.mobileDownloads',
      defaultMessage: '🏆 Download songs on the go from phone to laptop',
    },
    bpmsupreme: {
      id: 'djcity.common.comparison.bpmsupreme.mobileDownloads',
      defaultMessage: '🚫 Not available',
    },
    zipdj: {
      id: 'djcity.common.comparison.zipdj.mobileDownloads',
      defaultMessage: '🚫 Not available',
    },
  }),
  mobile: defineMessages({
    title: {
      id: 'djcity.common.comparison.title.mobile',
      defaultMessage: 'Mobile App',
    },
    djcity: {
      id: 'djcity.common.comparison.djcity.mobile',
      defaultMessage:
        '🏆 iOS and Android versions with full access and remote downloads',
    },
    bpmsupreme: {
      id: 'djcity.common.comparison.bpmsupreme.mobile',
      defaultMessage: 'No downloads',
    },
    zipdj: {
      id: 'djcity.common.comparison.zipdj.mobile',
      defaultMessage: '🚫 Not available',
    },
  }),
  genres: defineMessages({
    title: {
      id: 'djcity.common.comparison.title.genres',
      defaultMessage: 'Genres',
    },
    djcity: {
      id: 'djcity.common.comparison.djcity.genres',
      defaultMessage: '🏆 250+ genres',
    },
    bpmsupreme: {
      id: 'djcity.common.comparison.bpmsupreme.genres',
      defaultMessage: 'Less than 100 genres',
    },
    zipdj: {
      id: 'djcity.common.comparison.zipdj.genres',
      defaultMessage: '60+ genres',
    },
  }),
  recommendations: defineMessages({
    title: {
      id: 'djcity.common.comparison.title.recommendations',
      defaultMessage: 'Song Recommendations',
    },
    djcity: {
      id: 'djcity.common.comparison.djcity.recommendations',
      defaultMessage: '🏆 Find similar songs to expand music discovery',
    },
    bpmsupreme: {
      id: 'djcity.common.comparison.bpmsupreme.recommendations',
      defaultMessage: 'Limited availability',
    },
    zipdj: {
      id: 'djcity.common.comparison.zipdj.recommendations',
      defaultMessage: '🚫 Not available',
    },
  }),
}
export const faqMessages = [
  {
    uuid: '02d8842d-a300-48da-aaca-9e62c9792b61',
    msg: defineMessages({
      title: {
        id: 'djcity.common.comparison.faq.title1',
        defaultMessage: 'Why is DJcity the Best Download Record Pool for DJs?',
      },
      content: {
        id: 'djcity.common.comparison.faq.text1',
        defaultMessage:
          'Founded in 2000, DJcity is one of the longest-running and most trusted record pools, providing DJs worldwide with the latest club and radio hits in high-quality MP3 format.',
      },
    }),
  },
  {
    uuid: '99ab3605-fe37-4a05-95f7-6cde2fe2f23e',
    msg: defineMessages({
      title: {
        id: 'djcity.common.comparison.faq.title2',
        defaultMessage: 'What Makes DJcity Better Than Other Record Pools?',
      },
      content: {
        id: 'djcity.common.comparison.faq.text2',
        defaultMessage:
          'DJcity offers unmatched value with 250+ genres, exclusive remixes and edits, and flexible subscription plans with major savings.',
      },
    }),
  },
  {
    uuid: '264ce8fd-f1a8-4ab6-bef8-97ef2d7a517d',
    msg: defineMessages({
      title: {
        id: 'djcity.common.comparison.faq.title3',
        defaultMessage: 'Who Uses DJcity?',
      },
      content: {
        id: 'djcity.common.comparison.faq.text3',
        defaultMessage:
          'DJcity is an essential music source for beginner, club, radio, and expert DJs. Artists and performers who rely on DJcity include: Diplo, Tiesto, DJ Snake, Lil Jon, Vice, Walshy Fire (Major Lazer), Grandmaster Flash, James Hype, A-Trak, Joe Jonas, and Q-Tip.',
      },
    }),
  },
  {
    uuid: 'a93381bf-5322-4f19-8465-acce75602e43',
    msg: defineMessages({
      title: {
        id: 'djcity.common.comparison.faq.title4',
        defaultMessage: 'Where Can I Find DJcity Reviews?',
      },
      content: {
        id: 'djcity.common.comparison.faq.text4',
        defaultMessage:
          'DJcity is highly rated and endorsed by top DJ industry platforms, including Serato, Digital DJ Tips, Phase DJ, Crossfader, and DJ Techtools.',
      },
    }),
  },
]
